import { render, staticRenderFns } from "./cdSkinPackage1.vue?vue&type=template&id=cb698d7c&scoped=true"
import script from "./cdSkinPackage1.vue?vue&type=script&lang=js"
export * from "./cdSkinPackage1.vue?vue&type=script&lang=js"
import style0 from "./cdSkinPackage1.vue?vue&type=style&index=0&id=cb698d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb698d7c",
  null
  
)

export default component.exports